{
  "SEARCH": {
    "TABS": {
      "ALL": "Sve",
      "CONTACTS": "Kontakti",
      "CONVERSATIONS": "Razgovori",
      "MESSAGES": "Poruke"
    },
    "SECTION": {
      "CONTACTS": "Kontakti",
      "CONVERSATIONS": "Razgovori",
      "MESSAGES": "Poruke"
    },
    "VIEW_MORE": "Prikaži više",
    "LOAD_MORE": "Učitaj više",
    "SEARCHING_DATA": "Tražim",
    "LOADING_DATA": "Učitavanje",
    "EMPTY_STATE": "Pronađeno {item} za traženi pojam '{query}'",
    "EMPTY_STATE_FULL": "Ništa nije pronađeno za traženi pojam '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ za fokusiranje",
    "INPUT_PLACEHOLDER": "Unesi 3 ili više znakova za pretragu",
    "RECENT_MESSAGES": "Moje nedavno poslane poruke",
    "EMPTY_STATE_DEFAULT": "Traži po conversation id, e-mail, broj telefona, poruke za bolje rezultate pretrage. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Pročitaj više",
    "WROTE": "napisao/la:",
    "FROM": "od",
    "EMAIL": "email",
    "EMAIL_SUBJECT": "predmet"
  }
}
